import { DefaultRootState } from 'react-redux';
import { AnyAction, Middleware, ReducersMapObject } from 'redux';

import mutate from './mutators';

let actionsCache: ReturnType<ReturnType<Middleware>>[] | null = null;

export const hasActionsCache = (): boolean => !!actionsCache;
export const hasInjectData = (rootReducer: ReducersMapObject, data: DefaultRootState): boolean =>
    Object.keys(rootReducer).some((name) => data.hasOwnProperty(name));

export const inject = (
    fetchingDataAction: ReturnType<ReturnType<Middleware>>,
    SET_FIELD_DATA_AS_IS_CONST: string,
    data: DefaultRootState,
    params: { noTrl?: boolean } = {},
    resetSelectors: string[] = [],
    rootReducer: ReducersMapObject,
    globalVars = window.globalVars
): void => {
    const resetData = resetSelectors.reduce((resetState: Record<string, unknown>, reducerSelector) => {
        resetState[reducerSelector] = rootReducer[reducerSelector](undefined, {} as AnyAction);
        return resetState;
    }, {});

    actionsCache = [
        fetchingDataAction(false),
        {
            type: SET_FIELD_DATA_AS_IS_CONST,
            source: 'injectPageData',
            payload: mutate({ ...resetData, ...data }, params),
        },
    ];

    if (data?.request) {
        globalVars.requestId = data.request.id!;
    }

    if (data?.sentryExtraData) {
        globalVars.sentryExtraData = data.sentryExtraData;
    }

    if (data?.analyticsParams) {
        globalVars.analyticsParams = data.analyticsParams;
    }
};

export const extract = (
    originalAction: ReturnType<ReturnType<Middleware>>
): ReturnType<ReturnType<Middleware>> | ReturnType<ReturnType<Middleware>>[] => {
    if (!actionsCache) {
        return originalAction;
    }

    const actions = actionsCache;
    actionsCache = null;

    if (originalAction) {
        actions.push(originalAction);
    }

    return actions;
};
